import { render, staticRenderFns } from "./ReviewList.vue?vue&type=template&id=7e30c331&scoped=true&lang=html&"
import script from "./ReviewList.vue?vue&type=script&lang=coffee&"
export * from "./ReviewList.vue?vue&type=script&lang=coffee&"
import style0 from "./ReviewList.vue?vue&type=style&index=0&id=7e30c331&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e30c331",
  null
  
)

component.options.__file = "ReviewList.vue"
export default component.exports